import { useState } from 'react';
import { faqData, platformFeatures } from '@/mocks/homeData';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq-section" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            关于开云体育在线平台的常见疑问，我们为您一一解答
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-12">
          {platformFeatures.map((feature) => (
            <div key={feature.title} className="bg-background-100 rounded-lg p-4 text-center border border-background-200/60">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${feature.icon} text-primary-500 text-lg`}></i>
              </div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-1">{feature.title}</h4>
              <p className="text-xs text-foreground-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="max-w-[800px] mx-auto flex flex-col gap-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-100 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between p-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openId === faq.id ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}